import { type FC, type ReactElement } from "react";
import * as styles from "./styles.css";

type Props = {
  children: ReactElement[] | ReactElement;
};

export const DefinitionList: FC<Props> = ({ children }) => (
  <dl className={styles.definitionList}>{children}</dl>
);
